import React, { useState } from 'react'
import useFetch from '../../../hooks/useAxios';
import NotidicationCard from './notification/NotidicationCard'

const UserNotification = () => {
  const [notif, setnotif] = useState([])
  const fetchnotif = useFetch({
    method: "get",
    url: "api/notifications",
    noHeader: false,
    trigger: true,
    argFunc: res => {
      setnotif(res.data)
      
    }
  });
  return (
   <>
   {
     !fetchnotif.loading &&  <div className='UserNotification'>
    {notif.map(i=><NotidicationCard  info={i}  />) }
   
   </div>
   }
   </>
  )
}

export default UserNotification